module.exports = __webpack_public_path__ + "img/cooperative0_logo6.771d4bdc.jpg";